import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbers]'
})
export class OnlyNumbersDirective {

  constructor() { }
   

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (['e', 'E', '+', '-'].includes(event.key)) {
      event.preventDefault();
    }
  }

  // Block paste if it contains anything other than digits
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData?.getData('text') ?? '';
    if (!/^\d*$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  // prevent mouse scroll increment/decrement
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {
    (event.target as HTMLElement).blur();
  }
}
